module.exports = __webpack_public_path__ + "img/loading-ball.a746dfd7.gif";